export interface OrderFieldOption { value: string; aliases?: string[] }

const customerSources: Array<[string, string]> = [
  ["阿里巴巴", "Alibaba"], ["阿里复购", "Alibaba repeat"], ["阿里香港", "Alibaba Hong Kong"], ["复购", "Repeat customer"],
  ["个人资源", "Personal network"], ["官网", "Official website"], ["官网复购", "Website repeat"], ["老客户介绍", "Customer referral"],
  ["同事介绍", "Colleague referral"], ["同行推荐", "Industry referral"], ["展会", "Exhibition trade show"], ["GTI", "GTI"]
];
export const CUSTOMER_SOURCE_OPTIONS: OrderFieldOption[] = customerSources.map(([value, alias]) => ({ value, aliases: [alias] }));

const countries = `
阿富汗|Afghanistan
阿尔巴尼亚|Albania
阿尔及利亚|Algeria
安道尔|Andorra
安哥拉|Angola
安提瓜和巴布达|Antigua and Barbuda
阿根廷|Argentina
亚美尼亚|Armenia
澳大利亚|Australia
奥地利|Austria
阿塞拜疆|Azerbaijan
巴哈马|Bahamas
巴林|Bahrain
孟加拉国|Bangladesh
巴巴多斯|Barbados
白俄罗斯|Belarus
比利时|Belgium
伯利兹|Belize
贝宁|Benin
不丹|Bhutan
玻利维亚|Bolivia
波斯尼亚和黑塞哥维那|Bosnia and Herzegovina
博茨瓦纳|Botswana
巴西|Brazil
文莱|Brunei
保加利亚|Bulgaria
布基纳法索|Burkina Faso
布隆迪|Burundi
佛得角|Cabo Verde Cape Verde
柬埔寨|Cambodia
喀麦隆|Cameroon
加拿大|Canada
中非共和国|Central African Republic
乍得|Chad
智利|Chile
中国|China PRC
哥伦比亚|Colombia
科摩罗|Comoros
刚果共和国|Republic of the Congo
刚果民主共和国|Democratic Republic of the Congo DRC
哥斯达黎加|Costa Rica
科特迪瓦|Cote d'Ivoire Ivory Coast
克罗地亚|Croatia
古巴|Cuba
塞浦路斯|Cyprus
捷克|Czechia Czech Republic
丹麦|Denmark
吉布提|Djibouti
多米尼克|Dominica
多米尼加|Dominican Republic
厄瓜多尔|Ecuador
埃及|Egypt
萨尔瓦多|El Salvador
赤道几内亚|Equatorial Guinea
厄立特里亚|Eritrea
爱沙尼亚|Estonia
斯威士兰|Eswatini Swaziland
埃塞俄比亚|Ethiopia
斐济|Fiji
芬兰|Finland
法国|France
加蓬|Gabon
冈比亚|Gambia
格鲁吉亚|Georgia
德国|Germany
加纳|Ghana
希腊|Greece
格林纳达|Grenada
危地马拉|Guatemala
几内亚|Guinea
几内亚比绍|Guinea-Bissau
圭亚那|Guyana
海地|Haiti
洪都拉斯|Honduras
匈牙利|Hungary
冰岛|Iceland
印度|India
印度尼西亚|Indonesia
伊朗|Iran
伊拉克|Iraq
爱尔兰|Ireland
以色列|Israel
意大利|Italy
牙买加|Jamaica
日本|Japan
约旦|Jordan
哈萨克斯坦|Kazakhstan
肯尼亚|Kenya
基里巴斯|Kiribati
朝鲜|North Korea DPRK
韩国|South Korea Republic of Korea
科威特|Kuwait
吉尔吉斯斯坦|Kyrgyzstan
老挝|Laos
拉脱维亚|Latvia
黎巴嫩|Lebanon
莱索托|Lesotho
利比里亚|Liberia
利比亚|Libya
列支敦士登|Liechtenstein
立陶宛|Lithuania
卢森堡|Luxembourg
马达加斯加|Madagascar
马拉维|Malawi
马来西亚|Malaysia
马尔代夫|Maldives
马里|Mali
马耳他|Malta
马绍尔群岛|Marshall Islands
毛里塔尼亚|Mauritania
毛里求斯|Mauritius
墨西哥|Mexico
密克罗尼西亚|Micronesia
摩尔多瓦|Moldova
摩纳哥|Monaco
蒙古|Mongolia
黑山|Montenegro
摩洛哥|Morocco
莫桑比克|Mozambique
缅甸|Myanmar Burma
纳米比亚|Namibia
瑙鲁|Nauru
尼泊尔|Nepal
荷兰|Netherlands Holland
新西兰|New Zealand
尼加拉瓜|Nicaragua
尼日尔|Niger
尼日利亚|Nigeria
北马其顿|North Macedonia
挪威|Norway
阿曼|Oman
巴基斯坦|Pakistan
帕劳|Palau
巴勒斯坦|Palestine
巴拿马|Panama
巴布亚新几内亚|Papua New Guinea
巴拉圭|Paraguay
秘鲁|Peru
菲律宾|Philippines
波兰|Poland
葡萄牙|Portugal
卡塔尔|Qatar
罗马尼亚|Romania
俄罗斯|Russia Russian Federation
卢旺达|Rwanda
圣基茨和尼维斯|Saint Kitts and Nevis
圣卢西亚|Saint Lucia
圣文森特和格林纳丁斯|Saint Vincent and the Grenadines
萨摩亚|Samoa
圣马力诺|San Marino
圣多美和普林西比|Sao Tome and Principe
沙特阿拉伯|Saudi Arabia
塞内加尔|Senegal
塞尔维亚|Serbia
塞舌尔|Seychelles
塞拉利昂|Sierra Leone
新加坡|Singapore
斯洛伐克|Slovakia
斯洛文尼亚|Slovenia
所罗门群岛|Solomon Islands
索马里|Somalia
南非|South Africa
南苏丹|South Sudan
西班牙|Spain
斯里兰卡|Sri Lanka
苏丹|Sudan
苏里南|Suriname
瑞典|Sweden
瑞士|Switzerland
叙利亚|Syria
塔吉克斯坦|Tajikistan
坦桑尼亚|Tanzania
泰国|Thailand
东帝汶|Timor-Leste East Timor
多哥|Togo
汤加|Tonga
特立尼达和多巴哥|Trinidad and Tobago
突尼斯|Tunisia
土耳其|Turkey Türkiye
土库曼斯坦|Turkmenistan
图瓦卢|Tuvalu
乌干达|Uganda
乌克兰|Ukraine
阿联酋|United Arab Emirates UAE Dubai Abu Dhabi
英国|United Kingdom UK Great Britain
美国|United States USA America
乌拉圭|Uruguay
乌兹别克斯坦|Uzbekistan
瓦努阿图|Vanuatu
梵蒂冈|Vatican City Holy See
委内瑞拉|Venezuela
越南|Vietnam
也门|Yemen
赞比亚|Zambia
津巴布韦|Zimbabwe
中国香港|Hong Kong China HK
中国澳门|Macao Macau China
中国台湾|Taiwan China
波多黎各|Puerto Rico
关岛|Guam
百慕大|Bermuda
开曼群岛|Cayman Islands
英属维尔京群岛|British Virgin Islands
美属维尔京群岛|US Virgin Islands
特克斯和凯科斯群岛|Turks and Caicos Islands
库拉索|Curacao
阿鲁巴|Aruba
法属波利尼西亚|French Polynesia
新喀里多尼亚|New Caledonia
格陵兰|Greenland
法罗群岛|Faroe Islands
直布罗陀|Gibraltar
`.trim();

export const EXPORT_COUNTRY_OPTIONS: OrderFieldOption[] = countries.split("\n").map((line) => {
  const [value, aliases = ""] = line.split("|");
  return { value: value!, aliases: aliases.split(/\s{2,}|,(?=\s)/).filter(Boolean) };
});

export function fuzzyOrderFieldOptions(options: OrderFieldOption[], query: string, limit = 30): OrderFieldOption[] {
  const terms = query.trim().split(/\s+/u).map(normalizeSearchText).filter(Boolean);
  if (!terms.length) return options.slice(0, limit);
  return options.map((option, index) => {
    const value = normalizeSearchText(option.value);
    const aliases = normalizeSearchText(option.aliases?.join(" ") ?? "");
    const searchable = `${value} ${aliases}`;
    if (!terms.every((term) => searchable.includes(term))) return null;
    const score = terms.reduce((total, term) => total + (value === term ? 100 : value.startsWith(term) ? 60 : aliases.startsWith(term) ? 40 : 10), 0);
    return { option, index, score };
  }).filter((entry): entry is { option: OrderFieldOption; index: number; score: number } => entry !== null)
    .sort((left, right) => right.score - left.score || left.index - right.index).slice(0, limit).map((entry) => entry.option);
}

function normalizeSearchText(value: string): string {
  return value.normalize("NFKC").toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, "");
}
